import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    name: String,
  };

  dismiss() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    const data = {
      notification: {
        name: this.nameValue,
      },
    };

    return fetch('/notifications', {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Accept: 'application/json; charset=utf-8',
        'X-CSRF-Token': csrfToken,
      },
    }).catch((error) => {
      console.error('Failed to dismiss notification:', error);
    });
  }
}
